module.exports = __webpack_public_path__ + "public/img/qianggou.9a173031.png";